// Browsers may deny persistent storage. Keep the interface usable for this tab.
const fallback = new Map();
export function getPreference(key) {
  try { return localStorage.getItem(key) ?? fallback.get(key) ?? null; }
  catch { return fallback.get(key) ?? null; }
}
export function setPreference(key, value) {
  try { localStorage.setItem(key, value); fallback.delete(key); }
  catch { fallback.set(key, value); }
}
